export default {
    ACCOUNT_ID: 'UID',
    ACCOUNT_EMAIL: 'UEMAIL',
    ACCOUNT_TOKEN: 'UTOKEN',
    SUPER_ACCOUNT: 'SUPERACCOUNT',
    ACCOUNT_I18N: 'LANGUAGE',
    ACCOUNT_REGION: 'REGION',
    ACCOUNT_USERNAME: 'USER_NAME',
    LAST_PROFILE_ID: 'LAST_PROFILE_ID',
    LAST_PROFILE_SITE_ID: 'LAST_PROFILE_SITE_ID',
    ACCOUNT_SIGNUP_SOURCE: 'USOURCE',
    ANTI_FLICKER_TIP: 'ANTI_FLICKER_TIP',
    GOOGLE_API_KEY: 'AIzaSyC7kf6ze_2w-kmFkETx66pXWWyiAX0HdTk',
    GOOGLE_CLIENT_ID: '793584886590-kv21lcd0q9raf1hq70fvuc39sos1oh3f.apps.googleusercontent.com',
    ENGAGE_EDITOR_TOKEN: 'ptengine_engage_editor_token',
    ENGAGE_CONTROL_GROUP_TOKEN: 'ptengine_engage_control_group',
    CAMPAIGN_EDITOR_NAME: 'ptengine_campaign_editor',
    PREVIEW_TOKEN: 'preview_ptx_token',
    INTERACTIVE_DEMO_FLAG: 'INTERACTIVE_DEMO_PROFILES',
    PROFILE_EDITOR_URL: 'PROFILE_EDITOR_URL',
    PTI_UID: 'PTI_UID',
    PT_SIGNUP_PLAN: 'PT_SIGNUP_PLAN',
    PRODUCT_ACTIVE: 'PRODUCT_ACTIVE',
    SK_PLAN_PACKAGE_ID: 'OFFLINE-PTI-JP-ENTERPRISE-25K', //SK 套餐ID
    PHONE_MAX_LENGTH: 20,
    WEBSITE_MAX_LENGTH: 60,
    PROFILE_NAME_MAX_LENGTH: 60,
    ACCOUNT_NAME_MAX_LENGTH: 100,
    CAMPANY_NAME_MAX_LENGTH: 100,
    USER_INFO: 'userInfo',
    MICROSOFT_AUTH_KEY: 'AADACCOUNT',
    PTI_TIME_INFO: 'PTI_TIME_INFO',

    CookieRememberTime: 7 * 24 * 60 * 60,

    // 引导任务Key
    GUIDE_KEY: {
        USERS: ['anonymous_users', 'known_users', 'loyal_users']
    },
    CAN_VIEW_HEATMAP_V2: 'CAN_VIEW_HEATMAP_V2',
    AREA_CONF: {
        'localhost:3002': 'l',
        'dev.ptmind.com': '0',
        'dev.ptmind.cn': '1',
        'staging.ptmind.com': '2',
        'staging.ptmind.cn': '3',
        'www.ptengine.jp': '4',
        'www.ptengine.com': '5'
    },
    VIRTUAL_PROFILE_HIDE_MENUS: [
        'main.setting.profile',
        'main.setting.advertisement',
        'main.setting.traffictool'
    ] // 虚拟档案隐藏的menu
};
